import { ForwardedRef, forwardRef } from "react";
import { ETransactionType, TransactionsByFilter, TTransactionTypeFilter } from "../../shared/ITransaction";
import Dropdown, { IDropdown, TDropdownProps } from "../../gui/Dropdown/Dropdown";

export type TTransTypeSelectProps = Omit<TDropdownProps<ETransactionType>, "options"|"placeholder"|"float"|"anchorProps"> & {
    filter:TTransactionTypeFilter
}

export default forwardRef((props:TTransTypeSelectProps,ref?:ForwardedRef<IDropdown<ETransactionType>>) => {
    const {defaultValue,filter,...listProps} = props
    const options = TransactionsByFilter[filter]
    return <Dropdown options={options} defaultValue={defaultValue ?? options[0].id} placeholder="Action" float={true} ref={ref} {...listProps} anchorProps={{width:"match"}}/>
})